export default "__VITE_ASSET__dCM9Iz_C__"